// import { ConnectableElement, useDrag, useDrop } from "react-dnd";

// export function useDragDrop({
//   index,
//   moveItem,
//   onDrop,
// }: {
//   index: number;
//   moveItem: (dragIndex: number, hoverIndex: number) => void;
//   onDrop: (dragIndex: number, hoverIndex: number) => void;
// }) {
//   const [{ isDragging }, ref] = useDrag({
//     type: "ITEM",
//     item: { index },
//     collect: (monitor) => ({
//       isDragging: monitor.isDragging(),
//     }),
//   });

//   const [{ isOver }, drop] = useDrop({
//     accept: "ITEM",
//     hover: (draggedItem: { index: number }) => {
//       if (draggedItem.index !== index) {
//         moveItem(draggedItem.index, index);
//         draggedItem.index = index;
//       }
//     },
//     drop: (draggedItem: { index: number }) => {
//       // alert("Item dropped");
//       onDrop(draggedItem.index, index);
//     },
//     collect: (monitor) => ({
//       isOver: monitor.isOver(),
//     }),
//   });

//   const ddRef = (node: ConnectableElement) => {
//     if (typeof ref === "function") {
//       ref(drop(node));
//     }
//   };
//   return { ref, drop, ddRef, isOver, isDragging };
// }

import { useRef } from "react";
import { ConnectableElement, useDrag, useDrop } from "react-dnd";

export function useDragDrop({
  type = "ITEM",
  index,
  moveItem,
  onDrop,
}: {
  type: string;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  onDrop: (dragIndex: number, hoverIndex: number) => void;
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  const [{ isDragging }, drag] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: type,
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
    hover(item, monitor) {
      const draggedItem = item as { index: number };
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (!ref.current || dragIndex === hoverIndex) return;

      const hoverRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverRect.bottom - hoverRect.top) / 2;

      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - hoverRect.top;

      // 🌐 Scroll window when dragging near top/bottom
      const edgeOffset = 80;
      const scrollSpeed = 15;
      const { innerHeight, scrollY } = window;
      const pointerY = clientOffset.y;

      if (pointerY < edgeOffset) {
        window.scrollTo({ top: scrollY - scrollSpeed, behavior: "auto" });
      } else if (pointerY > innerHeight - edgeOffset) {
        window.scrollTo({ top: scrollY + scrollSpeed, behavior: "auto" });
      }

      // Same logic as before, but safe from scroll jumps
      // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      // Move and update index immediately like old logic
      moveItem(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    },
    drop(item, monitor) {
      const draggedItem = item as { index: number };
      const dragIndex = draggedItem.index;
      const hoverIndex = index; // this component’s index

      // If the final target differs from current index, update once more
      if (dragIndex !== hoverIndex) {
        moveItem(dragIndex, hoverIndex); // update state
        draggedItem.index = hoverIndex; // keep item in sync
      }

      onDrop(draggedItem.index, hoverIndex);
    },
  });

  const ddRef = (node: ConnectableElement | null) => {
    if (node) {
      drag(drop(node));
      ref.current = node as HTMLDivElement;
    }
  };

  return {
    ddRef,
    isOver,
    isDragging,
  };
}
